<!--
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-23 09:55:56
 * @LastEditTime: 2019-10-22 04:08:52
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id='liveDetail' @click='doNothing'>
    <div id='id_test_video'>
      <template v-if='liveObj'>
        <div class="liveName"  v-if="liveObj.status == 'PLAYING'">
          <img class="liveLogo" :src="liveObj.mallLogo" alt="" srcset="">
          <div>
            <div class="nameTop">{{liveObj.studioName}}</div>
            <div class="nameHot">
              <img class="liveHot" :src="picUrl.hot" alt="" srcset="">
              <div>{{userHotNum?userHotNum:0}}</div>
            </div>
          </div>
        </div>
        <div class="WAITING" v-if='liveObj.status === "WAITING"'>
          <img :src="picUrl.icon_live">
          <div>客官，活动直播尚未开始</div>
        </div>
        <span v-else-if='liveObj.status === "END" || isLiveDead'>直播已经结束，期待下一次相遇～</span>
        <span v-else-if="livestatus">主播暂时离开一下下，稍后回来~</span>
      </template>
    </div>
    <div class='explainGoodsWrap' v-if='livingCoupon'>
      <div class='explainGoods'>
        <div class='explainGoodsImg'>
          <img :src='livingCoupon.couponCover'>
        </div>
        <div class='explainGoodsDesc'>
          <div class='explainGoodsName'>
            <span class='tip'>讲解中</span>
            <span class='goodName'>{{livingCoupon.couponName}}</span>
          </div>
          <div class='explainGoodsPrice'>
            <div class='priceWrap'>
              <div class='price' v-if='livingCoupon.status==="ON_SHELF"'><span>¥</span>{{filterPrice(livingCoupon.price,1)}}<span>.{{filterPrice(livingCoupon.price)}}</span></div>
              <div class="price" v-if='livingCoupon.status==="DOWN_SHELF"'>???</div>
              <div class='stock' v-if='livingCoupon.status==="ON_SHELF"'>仅剩{{livingCoupon.surplusStock}}</div>
            </div>
            <div class='explainGoodsBuyBtn' v-if='livingCoupon.status==="ON_SHELF"&&livingCoupon.surplusStock>0' @click='goBuy(livingCoupon.studioCode,livingCoupon.couponCode)'>购买</div>
            <div class="explainGoodsBuyBtn disabled" v-else>购买</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹幕列表 -->
    <div class='msgListWrap'  ref='msgScroll'  @scroll="msgScroll">
      <div class='msgList'>
        <div class='msgItemWrap'>
          <div class='msgItem gg'>
            <img :src='picUrl.gonggao'>
            <div class='ggText'>欢迎来到直播间！我们提倡文明健康直播严禁任何违法、违规、低俗等不良内容，经举报或巡查发现将进行关闭聊天处理</div>
          </div>
        </div>
        <div class='msgItemWrap'  v-for='(item,index) in msgList' :key='index'>
          <div class='msgItem' v-if='item.userName && item.message'>
            <span v-if='item.messageType===2' class="anchor">主播</span><span class='userName'>{{item.userName}}</span><span class='message'>{{item.message}}</span>
          </div>
        </div>

        <div class="newNews" @click="viewMessage" v-if="isShowNews">
          <img :src="picUrl.icon_down" alt="" >查看新消息
        </div>
      </div>
    </div>
    <!-- 规则按钮 -->
    <div class="ruleBtn" @click='showRuleWrap'>规则</div>
    <!-- 底部输入框 -->
    <div class="fixedBtnWrap">
      <div class="fixedBtn">
        <div :class="{fixedBtnInput:true, isFocus:isFocus||textMsg.length>0}">
          <input type="text" name="" :placeholder="liveObj.bulletScreen&&inJoinSuccess?'说点儿什么吧～':'全员禁言中～'" v-model='textMsg' @focus='focusInput' @blur='blurInput' @keyup.enter='sendTextMsg' :disabled='!liveObj.bulletScreen||!inJoinSuccess' maxlength="30" ref='input'>
        </div>
        <div class="btnsWrap" v-show="!isFocus&&textMsg.length==0">
          <img :src="picUrl.icon_shopping" @click='showCartListWrap'>
          <img :src="picUrl.icon_xinke" @click='goMine'>
          <img :src="picUrl.icon_share" @click='startShare(true)'>
        </div>
        <div class="btnsWrap" v-show="textMsg.length>0||isFocus" @click='sendTextMsg' ref='sendInput'>
          <img :src="picUrl.icon_send">
        </div>
      </div>
    </div>
    <!-- 规则说明 -->
    <div :class="{ruleWrap:true, show:showRule}">
      <div :class="{ruleContent:true, g_scale1:showRule2 ,g_scale0:!showRule2}">
        <div class="ruleTitle">规则说明</div>
        <div class="ruleText" v-html='liveObj.rule'></div>
        <div class="ruleBtnWrap">
          <div class="innerBtn" @click='closeRuleWrap'>知道了</div>
        </div>
      </div>
    </div>
    <!-- 购物车 -->
    <div :class="{cartListWrap:true, show:showCartList}" @click='closeshowCartListWrap'>
      <div :class="{cartWrap:true, show:showCartList2}" @click.stop='catchStop'>
        <img :src="picUrl.icon_live_goods_close" class="closeBtn" @click='closeshowCartListWrap'>
        <div class="cartTitle">
          <span class="cartTitleText">直播商品</span><span class="cartNum" v-if='productList&&productList.length'>{{productList&&productList.length}}</span>
        </div>
        <div class="cartList">
          <div class="cartItem" v-for='(item,index) in productList' :key='index' v-if='productList&&productList.length'>
             <img :src="item.couponCover" class="cartImg">
             <div class="cartText">
               <div class="proName"><span class="tip" v-if='item.isLiving'>讲解中</span><span class="nameText">{{item.couponName}}</span></div>
               <div class="proPriceWrap">
                 <div class="priceWrap">
                   <div class="priceText" v-if='item.status==="ON_SHELF"'>
                     <span>¥</span>{{filterPrice(item.price,1)}}<span>.{{filterPrice(item.price)}}</span>
                   </div>
                   <div class="priceText" v-if='item.status==="DOWN_SHELF"'>
                     ???
                   </div>
                   <div class="stock" v-if='item.status==="ON_SHELF"'>仅剩{{item.surplusStock}}</div>
                 </div>
                 <div class="proBtn" v-if='item.status==="ON_SHELF"&&item.surplusStock>0' @click='goBuy(item.studioCode,item.couponCode)'>购买</div>
                 <div class="proBtn disabled" v-else>购买</div>
               </div>
             </div>
          </div>
          <div class="img_box" v-else>
            <img :src="picUrl.img_box">
            <div>暂无商品</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分享 -->
    <div :class="{shareWrap:true, show:shareBtnWrap}" @click='closeShareWrap'>
      <img :src="picUrl.guide" class="shareGuide">
      <div class="shareGuideText">分享给好友</div>
      <div :class="{shareContent:true, show:shareBtnWrap2}"  @click.stop='catchStop'>
        <div class="shareBtn" @click='showPoster'>
          <img :src="picUrl.icon_poster">
          <span>生成海报</span>
        </div>
        <!--  data-clipboard-action="copy"
             class="share_btn"
             :src="shareBtnUrl"
             ref="copy"
             :data-clipboard-text="shareLink"
             @click="clickShareBtn"
             alt=""> -->
         <div class="shareBtn" data-clipboard-action="copy"  @click='copyLink' ref="copy" :data-clipboard-text="shareLink">
          <img :src="picUrl.icon_link">
          <span>复制链接</span>
        </div>
        <img :src="picUrl.btn_closer" class="closeShare" @click='closeShareWrap'>
      </div>
    </div>
    <!-- 生成海报 -->
    <div :class="{posterWrap:true, show:showPosterWrap}">
      <div :class="{posterWrapContent:true, g_scale1:showPosterWrap2 ,g_scale0:!showPosterWrap2}">
        <div class="posterText">长按保存图片</div>
        <img :src='sharePosters' class="posterImg">
        <div class="closePoster" @click='closePoster'>
          <img :src="picUrl.H5_btn_close">
        </div>
      </div>
    </div>
    <div id='errorScreen'>
      <div class="screenText">如需全屏观看，请点击全屏按钮播放</div>
    </div>
    <input id="copy_content" type="text"   v-model='shareLink'  style="position: absolute;top: 0;left: 0;opacity: 0;z-index: -10;"/>
  </div>
</template>
<script>
/* eslint-disable */
let player = null
let timer = null
import TIM from 'tim-js-sdk';
import COS from 'cos-js-sdk-v5';

let options = {
  SDKAppID: 1400321568 // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
};
// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
let tim = TIM.create(options); // SDK 实例通常用 tim 表示
// 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
// 普通级别，日志量较多，接入时建议使用
// tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
if (process.env.NODE_ENV === "development") {
  tim.setLogLevel(0);
}else {
  tim.setLogLevel(1);
}
// 注册 COS SDK 插件
tim.registerPlugin({'cos-js-sdk': COS});

import { jsonDateFormat, getImageList, appShareClick } from '@/utils/index.js'
import { buriedPoint } from '@/utils/utils.js'
let roomInfo = {
  roomID: '', // 视频位房间ID
  roomInfo: '', // 房间名称
  mixedPlayURL: '', // 混流地址
  isCreator: false, // 是否为创建者
  pushers: [], // 当前用户信息
  isLoginIM: true, // 是否登录IM
  isJoinGroup: false, // 是否加入群
  isDestory: false, // 是否已解散
  hasJoinAnchor: false,
  roomStatusCode: 0,
  toUserId: '',
  accelerateURL: ''
}
export default {
  name: 'activityDetail',
  components: {},
  data() {
    return {
      /**
       * 推广弹窗
       */
      isShowShareAlert: false, // 是否展示推广弹窗
      isShowRule: false, // 是否展示规则
      /**
       * 静态图片
       */
      picUrl: {},
      /**
       * 页面数据
       */
      activityData: {}, // 页面数据
      isShowBarrage: false,
      barrageArr: [], // 弹幕集合
      bannerList: [], // 顶部swiper
      activityList: [], // 营销活动
      couponList: [], // 卡券列表
      storeInfo: [], // 参与店铺集合
      avatarList: [], // 报名头像集合
      /**
       * 下方按钮判断条件
       */
      popularizeFlag: true, // 是否推广
      dateType: 0, // 活动时间判断
      salesCouponPrice: 0, // 报名费
      mallId: 0, // 商场编号
      /**
       * BUY('立即抢购'),
       * ENROLL('立即报名'),
       * ENROLL_AND_GET('立即报名领取'),
       * ENROLL_AND_BUY('立即报名抢购'),
       * ENROLL_INFO('报名信息');）
       * 如果接口返回ENROLL_INFO，那按钮显示报名信息，其余情况根据返回报名费展示按钮。
       */
      motivateBuyType: '', // 蓄客购买类型
      activityLocationData: null, // 活动地址
      deviceType: 0, // 设备类型
      /**
       * 直播相关参数
       */
      hasLive: false, //是否绑定直播 直播是否在进行中
      isShowLive: false, // 是否显示直播
      isPlay: false, // 是否正在播放
      playTime: 0, // 当前播放时长
      playTimeDefault: 0, // 播放开始时长
      playStartTime: 0, //播放开始时间
      livePullUrl: '', //拉流地址
      liveWatchTime: 60, // 直播需要观看时间
      nowLocationData: {
        // 当前位置信息
        latitude: '',
        longitude: ''
      },
      isRewardLivePresent: false, // 是否已经获得直播奖励
      msgList:[],
      livestatus:false,
      isShowNews:false,
      /**
       * 静态图片
       */
      picUrl: {
        gonggao:this.$store.state.ossLink + 'live/icon_gonggao@2x.png',
        icon_shopping:this.$store.state.ossLink + 'live/icon_shopping@2x.png',
        icon_share:this.$store.state.ossLink + 'live/icon_share@2x.png',
        icon_xinke:this.$store.state.ossLink + 'live/icon_xinke@2x.png',
        icon_send:this.$store.state.ossLink + 'live/icon_send@2x.png',
        icon_live_goods_close:this.$store.state.ossLink + 'live/icon_live_goods_close@2x.png',
        guide:this.$store.state.ossLink + 'live/guide@2x.png',
        icon_poster:this.$store.state.ossLink + 'live/icon_poster@2x.png',
        icon_link:this.$store.state.ossLink + 'live/icon_link@2x.png',
        btn_closer:this.$store.state.ossLink + 'live/btn_closer@2x.png',
        H5_btn_close:this.$store.state.ossLink + 'live/H5_btn_close@2x.png',
        img_box:this.$store.state.ossLink + 'live/img_box@2x.png',
        icon_live:this.$store.state.ossLink + 'live/icon_live@2x.png',
        xym:this.$store.state.ossLink + 'live/xym@2x.png',
        hot:this.$store.state.ossLink + 'live/hot@2x.png',
        icon_down:this.$store.state.ossLink + 'live/icon_down@2x.png',
      },
      accountInfo: {
        userID:''
      },
      groupID: "honor",
      isFocus:false,//是否获取焦点
      textMsg:'',
      showRule:false,
      showRule2:false,
      showCartList:false,
      showCartList2:false,
      shareBtnWrap:false,
      shareBtnWrap2:false,
      showPosterWrap:false,
      showPosterWrap2:false,
      livingCoupon:'',//当前直播的商品
      inJoinSuccess:false,//是否加入成功
      productList:[],//购物车列表
      liveObj:'',//直播信息
      studioCode:'',
      shareLink:'',
      posterImg:'',
      isLiveDead:false, //直播间是否还存在
      requestNum:1,
      msgTimeout:null,
      isShowTop:false,
      initialH:'',
      userHotNum:'',
      sharePosters:''
    }
  },
  methods: {
    /**
     * 点击推广按钮
     */
    startShare(val) {
      if (val) {
        this.isShowFirendUsedTicket = false
        this.registerStarGuestInfo().then(()=>{
          this.showShareWrap()
        })
      } else {
        this.isShowShareAlert = val
        this.isShowRule = false
      }
    },
    /* eslint-enable */
    /**
     * 获取openid
     */
    getOpenId () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/alliance2/star/guest/account/total/obtain/my/account'
        })
        .then(res => {
          if (res.success) {
            localStorage.setItem('share_saleOrgNo', res.data.starGuestNo)
            localStorage.setItem('WECHAT_OPEN_ID', res.data.starGuestNo)
            localStorage.setItem('share_saleOrgType', 'STAR_GUEST')
            localStorage.setItem('share_clerkId', '')
            // this.$router.push({ path: '/activityShare', query: { popularizeNo: self.activityData.popularizeNo, popularizeId: self.activityData.popularizeId } })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getShareInfo (shareTitle, shareText, shareImage) {
      // 获取分享海报的内容
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/share/to/picture',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
          }
        })
        .then(res => {
          if (res.success) {
            self.sharePosters = res.data.posterUrl
            self.wxShare(shareTitle, shareText, shareImage, res.data.qrCodeUrl)
          } else {
            self.wxShare(shareTitle, shareText, shareImage, null)
          }
        })
        .catch(err => {
          console.log(err)
          self.wxShare(shareTitle, shareText, shareImage, null)
        })
    },
    /**
     * 判断是否已经是星客
     */
    getIsStarGuestResquest (shareTitle, shareText, shareImage) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/alliance2/star/guest/check/is/star/guest'
        })
        .then(res => {
          if (res.success && res.data) {
            self.getShareInfo(shareTitle, shareText, shareImage)
          } else {
            self.wxShare(shareTitle, shareText, shareImage, null)
          }
        })
        .catch(err => {
          console.log(err)
          self.wxShare(shareTitle, shareText, shareImage, null)
        })
    },
    /**
     * /h5/star/alliance2/star/guest/register/star/guest/info
     * 注册星客
     */
    registerStarGuestInfo () {
      return new Promise((resolve, reject) => {
        let isStar = localStorage.getItem('IS_CIMEN_STAR_USER')
        let self = this
        if (isStar && isStar === 'TRUE') {
          self.getOpenId()
          resolve()
        }
        let sourceType = localStorage.getItem('saleOrgType')
        let sourceNo = localStorage.getItem('saleOrgNo')
        if (sourceType === 'STORE') {
          let clerkId = localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : ''
          sourceNo = clerkId
        }
        self.$fly
          .request({
            method: 'post',
            url: '/h5/star/alliance2/star/guest/register/star/guest/info',
            params: {
              sourceType: sourceType,
              sourceNo: sourceNo,
              sourceActivityId: localStorage.getItem('activityId')
            }
          })
          .then(res => {
            if (res.success) {
              localStorage.setItem('IS_CIMEN_STAR_USER', 'TRUE')
              self.getOpenId()
              resolve()
            }
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    /**
     * h5获取蓄客活动信息
     */
    getActivityInfo () {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/query/info',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId')
          }
        })
        .then(res => {
          if (res.success) {
            console.log(res.data)
            // self.popularizeId = res.data.popularizeId
            // self.requestGetLiveDetail
            self.wxShare(res.data.shareTitle, res.data.shareText, res.data.shareImage, null)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 定时获取直播是否在进行中
     */
    breathToGetLiveDetail () {
      let self = this
      self.requestGetLiveDetail()
      self.clearTimeInterval()
      timer = setInterval(() => {
        self.requestGetLiveDetail()
      }, 10000)
    },
    /**
     * 获取直播信息
     * /h5/star/task/popularize/watch/live/prize/config
     * popularizeId
     */
    requestGetLiveDetail () {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/popularize/watch/live/prize/config',
          params: {
            popularizeId: self.popularizeId
          }
        })
        .then(res => {
          if (res.success) {
            // self.dealWithLiveDetail(res.data)
            self.liveWatchTime = res.data.watchTime
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 处理直播信息
     */
    dealWithLiveDetail (liveDetail) {
      if (!liveDetail.isAllowLive) {
        // 该活动不允许直播
        this.clearTimeInterval()
        return
      }
      if (liveDetail.isLiving) {
        // 如果直播进行中
        this.hasLive = true
        this.livePullUrl = liveDetail.pullAddress
        this.liveWatchTime = liveDetail.watchTime
      } else {
        if (this.hasLive) {
          this.$weui.toast('当前直播已结束', {
            duration: 2000,
            className: 'toast_text'
          })
          this.changePlay(false)
        }
        // 如果直播不在进行中 / 结束
        this.hasLive = false
        this.changeLiveShow(false)
      }
    },
    /**
     * 点击切换直播组件 并创建播放器
     */
    changeLiveShow (isShowLive) {
      this.isShowLive = isShowLive
      // this.refreshSwiperScroll()
      let self = this
      if (isShowLive) {
        this.$nextTick(() => {
          self.startLivePlay()
        })
      } else {
        if (player) player.destroy()
      }
    },
    /**
     * 开启直播
     */
    /* eslint-disable */
    startLivePlay() {
      // return;
      let self = this
      // console.log(player)
      if (player) player.destroy()
      player = null
      // self.changePlay(false)
      // console.log(self.livePullUrl)
      player = new TcPlayer('id_test_video', {
        m3u8: self.liveObj.pullAddress, //请替换成实际可用的播放地址
        autoplay: true, //iOS 下 safari 浏览器是不开放这个能力的
        live: true,
        // x5_fullscreen: true,
        systemFullscreen: true,
        x5_type: 'h5-page',
        poster: { style: 'stretch', src: self.liveObj.liveCoverUrl},
        wording: {
          2032: '请求视频失败，请检查网络',
          2048: '请求m3u8文件失败，可能是网络错误或者跨域问题',
          13: '直播已结束，请稍后再来',
          1001: '主播暂时离开一下下，稍后回来~',
          2:'主播暂时离开一下下，稍后回来~',
          3:'直播异常,请刷新网页后重试'
        },
        listener: msg => {
          self.dealWithPlayerMessage(msg)
        }
      })
    },
    /* eslint-enable */
    changePlay (isPlay) {
      this.isPlay = isPlay
      if (!isPlay) {
        this.playTime = 0 // 当前播放时长
        this.playStartTime = 0 // 播放开始时间
        this.playTimeDefault = 0
      }
    },
    dealWithPlayerMessage (message) {
      console.log(message, 'message？？')
      let self = this
      // let self = this
      if (message.type === 'fullscreen') {
        // player.fullscreen(true)
        player.play()
        // buriedPoint('FULL_SCREEN', self.liveObj.studioCode)
      } else if (message.type === 'timeupdate') {
        // 开始直播拉流
        self.isPlay = true
        self.startPullLive(message.timeStamp)
      } else if (message.type === 'pause') {
        // 视频暂停
        self.changePlay(false)
      } else if (message.type === 'playing') {
        // 视频播放
        self.changePlay(true)
      } else if (message.type === 'progress') {
        // if (!player.playing()) {
        //   player.play()
        // }
      } else if (message.type === 'load') {
        // self.$weui.toast('当前网络不佳', {
        //   duration: 3000,
        //   className: 'weui-toast-center'
        // })
        // setTimeout(() => {
        //   if (!player.playing()) {
        //     player.play()
        //   }
        // }, 5000)
      } else if (message.type !== 'progress') {
        console.warn(message)
      }
    },
    /**
     * 开始视频拉流 并统计时间
     */
    startPullLive (timeStamp) {
      if (!this.isPlay || !this.liveWatchTime) return
      if (this.playTimeDefault === 0) {
        this.playTimeDefault = timeStamp // 毫秒
        this.playStartTime = new Date().valueOf()
      }
      this.playTime = timeStamp - this.playTimeDefault // 毫秒
      console.log(this.playTime)
      if (this.playTime > this.liveWatchTime * 1000) {
        this.requestGetLiveRewards()
      }
    },
    /**
     * 请求直播奖励接口
     * /h5/star/task/enroll/handler/activity/watch/live
     */
    requestGetLiveRewards () {
      let self = this
      if (this.isRewardLivePresent) {
        return
      }
      this.isRewardLivePresent = true
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/handler/activity/watch/live',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            latitude: self.nowLocationData.latitude,
            longitude: self.nowLocationData.longitude,
            playStartTime: self.playStartTime
          }
        })
        .then(res => {
          if (res.success) {
            console.log('请求直播奖励接口')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 导航到活动地址
     */
    navigateToActivity () {
      let self = this
      const wechatMapKey = self.$store.state.qqMapSDK
      let navigateUrl = `https://apis.map.qq.com/tools/routeplan/eword=${self.activityLocationData.title}&epointx=${self.activityLocationData.location.lng}&epointy=${
        self.activityLocationData.location.lat
      }?referer=myapp&key=${wechatMapKey}`
      location.href = navigateUrl
    },
    clickToEnroll () {
      let self = this
      if (self.deviceType !== 0) return
      let contentText = '需要报名后才能领取哟~'
      if (self.salesCouponPrice !== 0) {
        contentText += '报名费￥' + self.salesCouponPrice + '，报名费不予退还'
      }
      if (self.dateType === -1) {
        this.$weui.dialog({
          title: '提示',
          content: '报名活动还未开始哦！',
          className: 'custom-classname',
          buttons: [
            {
              label: '知道了',
              type: 'primary',
              onClick: function () {
                console.log('ok')
              }
            }
          ]
        })
        return
      } else if (self.dateType === 1) {
        this.$weui.dialog({
          title: '提示',
          content: '报名活动已结束！',
          className: 'custom-classname',
          buttons: [
            {
              label: '知道了',
              type: 'primary',
              onClick: function () {
                console.log('ok')
              }
            }
          ]
        })
        return
      }
      self.$weui.dialog({
        title: '提示',
        content: contentText,
        className: 'custom-classname',
        buttons: [
          {
            label: '暂不领取',
            type: 'default',
            onClick: function () {
              console.log('cancel')
            }
          },
          {
            label: '立即报名',
            type: 'primary',
            onClick: function () {
              console.log('ok')
              self.getRedirectType()
            }
          }
        ]
      })
    },
    /**
     * h5获取蓄客活动购买跳转类型
     */
    getRedirectType () {
      this.$router.push('/activityRegisterSubmit')
    },
    /**
     * /h5/star/task/enroll/handler
     * h5报名
     */
    motivationActivityEnroll () {
      // 提交
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/h5/star/task/enroll/handler',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            mallId: self.mallId, // 商场编号
            salesCouponPrice: self.salesCouponPrice, // 付款金额
            motivateBuyType: self.motivateBuyType // 报名购买类型
          }
        })
        .then(res => {
          if (res.success) {
            if (res.data) {
              var urlType = res.data.split('type=')[1]
              if (urlType === 'ENROLL_DIALOG') {
                self.$weui.dialog({
                  title: '提示',
                  content: '报名成功！',
                  className: 'custom-classname',
                  buttons: [
                    {
                      label: '确定',
                      type: 'primary',
                      onClick: function () {
                        console.log('ok')
                      }
                    }
                  ]
                })
              } else {
                window.location.href = res.data
              }
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * /h5/star/task/enroll/handler/activity/read
     * 阅读奖励（获取位置后调用）
     */
    getLocationRequest (latitude, longitude) {
      let self = this
      self.nowLocationData = {
        latitude: latitude,
        longitude: longitude
      }
      self.$fly
        .request({
          method: 'get',
          url: '/h5/star/task/enroll/handler/activity/read',
          params: {
            saleOrgType: localStorage.getItem('saleOrgType'),
            saleOrgNo: localStorage.getItem('saleOrgNo'),
            activityId: localStorage.getItem('activityId'),
            clerkId: localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '',
            latitude: latitude,
            longitude: longitude
          }
        })
        .then(res => {
          if (res.success) {
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    wxShare (shareTitle, shareText, shareImage, shareSpecLink) {
      localStorage.setItem('STAR_ACTIVITY_SHARE_TITLE', shareTitle)
      localStorage.setItem('STAR_ACTIVITY_SHARE_TEXT', shareText)
      localStorage.setItem('STAR_ACTIVITY_SHARE_IMAGE', shareImage)
      let self = this
      let shareUrlNew =
        document.location.protocol +
        '//' +
        location.host +
        '/index.html#/?saleOrgType=' +
        localStorage.getItem('saleOrgType') +
        '&saleOrgNo=' +
        localStorage.getItem('saleOrgNo') +
        '&activityId=' +
        localStorage.getItem('activityId') +
        '&clerkId=' +
        (localStorage.getItem('clerkId') ? localStorage.getItem('clerkId') : '') +
        '&studioCode=' + self.studioCode
      let shareUrl = shareUrlNew
      if (shareSpecLink && shareSpecLink !== 'undefined') {
        shareUrl = shareSpecLink
      }
      console.log(localStorage.getItem('wechatId'))
      self.$fly
        .request({
          method: 'get',
          url: '/component/wechat/login/get/js/config/stat',
          params: {
            url: encodeURIComponent(location.href.split('#')[0])
          }
        })
        .then(res => {
          if (res.success) {
            self.$wx.config({
              debug: false,
              appId: res.data.appId,
              timestamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              signature: res.data.signature,
              jsApiList: [
                'hideAllNonBaseMenuItem',
                'showAllNonBaseMenuItem',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'showMenuItems',
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'getLocation'
              ]
            })
            self.$wx.ready(function () {
              self.$wx.hideAllNonBaseMenuItem()
              self.$wx.showMenuItems({
                menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3 ,
              })
              // 隐藏分享
              self.$wx.getLocation({
                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function (res) {
                  console.log(res)
                  var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
                  var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
                  // var speed = res.speed; // 速度，以米/每秒计
                  // var accuracy = res.accuracy; // 位置精度
                  if (res.latitude && res.longitude) {
                    self.getLocationRequest(latitude, longitude)
                  }
                },
                fail: function (res) {
                  console.log(res)
                  self.getLocationRequest('', '')
                }
              })
              self.$wx.updateAppMessageShareData({
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                  // console.log(1)
                  // buriedPoint('SHARE_LIVE', self.liveObj.studioCode)
                },
                trigger: function () {
                  console.log(111)
                },
                fail: function () {
                  self.$wx.onMenuShareAppMessage({
                    title: shareTitle, // 分享标题
                    desc: shareText, // 分享描述
                    link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: shareImage, // 分享图标
                    success: function () {
                      // 设置成功
                      // console.log(2)
                      // buriedPoint('SHARE_LIVE', self.liveObj.studioCode)
                    },
                    complete: function () {
                      // console.log(22)
                      // buriedPoint('SHARE_LIVE', self.liveObj.studioCode)
                    },
                    fail: function () {
                      window.location.reload()
                    }
                  })
                }
              })
              self.$wx.updateTimelineShareData({
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                  // console.log(3)
                  // console.log(33)
                  // buriedPoint('SHARE_LIVE', self.liveObj.studioCode)
                }
              })
              self.$wx.onMenuShareTimeline({// 分享到朋友圈
                title: shareTitle, // 分享标题
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 用户点击了分享后执行的回调函数
                  console.log(5)
                  // buriedPoint('SHARE_LIVE', self.liveObj.studioCode)
                }
              })
              self.$wx.onMenuShareAppMessage({// 分享给朋友
                title: shareTitle, // 分享标题
                desc: shareText, // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: shareImage, // 分享图标
                success: function () {
                  // 设置成功
                }
              })
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    clearTimeInterval () {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    },
    loginIM () {
      let self = this
      self.$fly
        .request({
          method: 'post',
          url: '/live/manage/im/h5/add'
        })
        .then(res => {
          if (res.success) {
            console.log(res)
            this.imUserId = res.data.imUserId
            this.accountInfo.userID = this.imUserId
            this.accountInfo.avatar = res.data.avatar
            this.accountInfo.nickName = res.data.nickName
            let promise = tim.login({userID: res.data.imUserId, userSig: res.data.sign})
            promise.then(function (imResponse) {
              console.log(imResponse.data, '222') // 登录成功
              if (imResponse.data.repeatLogin === true) {
                // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
                console.log(imResponse.data.errorInfo)
              }
              self.joinGroup()
              self.initListen()
            }).catch(function (imError) {
              console.warn('login error:', imError) // 登录失败的相关信息
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /* eslint-enable */
    joinGroup () {
      let self = this
      let promise = tim.joinGroup({ groupID: this.liveObj.groupId, type: TIM.TYPES.GRP_AVCHATROOM })
      promise.then(function (imResponse) {
        console.log(imResponse, 'joinGroup')
        self.inJoinSuccess = true
        switch (imResponse.data.status) {
          case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
            break
          case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
            // tim.on(TIM.EVENT.SDK_READY, self.onSdkReady)
            console.log(imResponse.data.group, '666') // 加入的群组资料
            self.heartbeatTimeout()
            break
          case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
            self.heartbeatTimeout()
            break
          default:
            break
        }
      }).catch(function (imError) {
        self.inJoinSuccess = false
        // self.$weui.dialog({
        //   title: '提示',
        //   content: '直播尚未开始或者已关闭',
        //   className: 'custom-classname',
        //   buttons: [
        //     {
        //       label: '确定',
        //       type: 'primary',
        //       onClick: function () {
        //         console.log('ok')
        //       }
        //     }
        //   ]
        // })
        console.warn('joinGroup error:', imError) // 申请加群失败的相关信息
      })
    },
    quitGroup () {
      let promise = tim.quitGroup(this.liveObj.groupId)
      promise.then(function (imResponse) {
        console.log(imResponse.data.groupID, 'quitGroup')// 退出成功的群 ID
      }).catch(function (imError) {
        console.warn('quitGroup error:', imError)// 退出群组失败的相关信息
      })
    },
    initListen () {
      let self = this
      let onMessageReceived = function (event) {
        console.log(event, '最顶层的IM消息')
        self.formatMsg(event)
      }
      tim.on(TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived)
    },
    formatMsg (newMsgListData) {
      let self = this
      let newMsgList = newMsgListData.data
      for (let j = 0; j < newMsgList.length; j++) {
        let str = ''
        for (let i = 0; i < newMsgList[j]._elements.length; i++) {
          if (newMsgList[j]._elements[i].type === 'TIMCustomElem') {
            str += newMsgList[j]._elements[i].content.data
          }
          if (newMsgList[j]._elements[i].type === 'TIMTextElem') {
            str += newMsgList[j]._elements[i].content.text
          }
        }
        newMsgList[j]._elements[0].content = str
        // console.log(newMsgList[j], 'newMsgList[j]')
        self.receiveMsg(newMsgList[j])
      }
    },
    // 获取群组人员数量
    getGroupProfile (groupID, callOk, callErr) {
      let promise = tim.getGroupProfile({ groupID: groupID, groupCustomFieldFilter: [] })
      promise.then(function (imResponse) {
        console.log(imResponse.data.group)
        callOk(imResponse.data.group)
      }).catch(function (imError) {
        callErr(imError)
        console.warn('getGroupProfile error:', imError) // 获取群详细资料失败的相关信息
      })
    },
    /* eslint-disable */
    receiveMsg (newMsg) {
      let self = this
      let newMsgData = newMsg[0] ? newMsg[0] : newMsg
      console.log(newMsgData._elements[0].content ,newMsgData.payload.data,'121212')
      let msg = {
        content: newMsgData._elements[0].content || newMsgData.payload.data,
        fromAccount: newMsgData.from,
        fromAccountNick: newMsgData.nick,
        id: newMsgData.id,
        userHot:newMsgData.payload.data
      }
      console.log(msg, 'msgmsgmsg')
      // console.log(msg, newMsg, 'msgmsgmsg')
      console.log('IM消息: ', JSON.stringify(msg))
      let time = new Date()
      let h = time.getHours() + ''
      let m = time.getMinutes() + ''
      let s = time.getSeconds() + ''
      h.length === 1 ? (h = '0' + h) : ''
      m.length === 1 ? (m = '0' + m) : ''
      s.length === 1 ? (s = '0' + s) : ''
      time = h + ':' + m + ':' + s
      msg.time = time
      // debugger;
      if (newMsgData.from === '@TIM#SYSTEM' && (newMsgData.payload.operationType === 5 || newMsgData.payload.groupJoinType === 1)) {
        if (newMsgData.payload.operationType === 5) {
          msg.fromAccountNick = ''
          msg.content = msg.content.split(';')
          msg.content = msg.content[0]
          self.onRecvRoomTextMsg && self.onRecvRoomTextMsg({
            roomID: roomInfo.roomID,
            userID: msg.fromAccount ? msg.fromAccount : msg.fromAccountNick,
            userName: msg.userName,
            userAvatar: msg.userAvatar,
            message: newMsgData,
            time: msg.time
          })
        }
        if (newMsgData.payload.groupJoinType === 1) {
          self.getGroupProfile(newMsgData.payload.groupProfile.groupID, function (res) {
            msg.fromAccountNick = '';
            // if(msg.content){
              msg.content = msg.content.split(';')
              msg.content = msg.content[0]
            // }
            self.onRecvRoomTextMsg && self.onRecvRoomTextMsg({
              roomID: roomInfo.roomID,
              userID: msg.fromAccount ? msg.fromAccount : msg.fromAccountNick,
              userName: msg.userName,
              userAvatar: msg.userAvatar,
              message: res,
              time: msg.time,
              type: 'getGroupProfile'
            })
          }, function (res) {

          })
        }
      } else if (msg.fromAccountNick === '@TIM#SYSTEM') {
        msg.fromAccountNick = ''
        msg.content = msg.content.split(';')
        msg.content = msg.content[0]
        self.onRecvRoomTextMsg && self.onRecvRoomTextMsg({
          roomID: roomInfo.roomID,
          userID: msg.fromAccount ? msg.fromAccount : msg.fromAccountNick,
          userName: msg.userName,
          userAvatar: msg.userAvatar,
          message: msg.content,
          time: msg.time
        })
      } else {
        var contentObj, newContent
        try {
          if (msg.content.search('}}}') !== -1) {
            newContent = msg.content.split('}}}')
            contentObj = JSON.parse(newContent[0] + '}}}')
          } else if (msg.content.search('}}') !== -1) {
            newContent = msg.content.split('}}')
            contentObj = JSON.parse(newContent[0] + '}}')
          } else {
            console.log(msg.content, '!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!')
            newContent = msg.content
            contentObj = newContent ? JSON.parse(newContent) : ''
          }
          
          
        } catch (e) {
          console.warn('IM消息解析异常，重新按json格式解析')
          newContent = new Array(1)
          newContent[0] = msg.content
          contentObj = JSON.parse(msg.content)
        }

        if (contentObj.toUserId && contentObj.toUserId !== undefined && contentObj.toUserId !== '' && contentObj.toUserId !== self.accountInfo.userID) {
          return
        }
        if (msg.id && msg.id !== roomInfo.roomID) {
          return
        }
        if (contentObj.cmd === 'CustomTextMsg') {
          msg.userName = contentObj.data.nickName
          msg.userAvatar = contentObj.data.headPic
          msg.messageType = contentObj.data.messageType
          let content = ''
          for (let i = 1; i < newContent.length; i++) {
            if (i === newContent.length - 1) {
              content += newContent[i]
            } else content += newContent[i] + '}}'
          }
          msg.content = content
          self.onRecvRoomTextMsg && self.onRecvRoomTextMsg({
            roomID: roomInfo.roomID,
            userID: msg.fromAccount ? msg.fromAccount : msg.fromAccountNick,
            userName: msg.userName,
            userAvatar: msg.userAvatar,
            message: msg.content,
            time: msg.time,
            messageType: msg.messageType
          })
        } else if (contentObj.cmd === 'CustomCmdMsg') {
          msg.userName = contentObj.data.nickName
          msg.userAvatar = contentObj.data.headPic
          msg.cmd = contentObj.data.cmd
          // let content = ''
          // for (let i = 1; i < newContent.length; i++) {
          //   if (i === newContent.length - 1) {
          //     content += newContent[i]
          //   } else content += newContent[i] + '}}'
          // }
          msg.content = contentObj.data.msg
          if (contentObj.data.cmd === 'starLiveImCustomMsg') {
    //          OPEN_THE_BARRAGE("开启弹幕禁止弹幕"),
    // CLOSE_THE_BARRAGE("禁止弹幕"),
    // SWITCH_GOODS("切换商品");
            if(contentObj.data.msg === 'SWITCH_GOODS'){
              self.getLivingCoupon(self.studioCode)
              self.getLivingCouponList(self.studioCode)
            }
            if(contentObj.data.msg === 'OPEN_THE_BARRAGE'){
              self.liveObj.bulletScreen = true
            }
            if(contentObj.data.msg === 'CLOSE_THE_BARRAGE'){
              self.liveObj.bulletScreen = false
            }
          }
          if(contentObj.data.cmd === 'heartbeat') {
            self.heartbeat()
          }
          if(contentObj.data.cmd == 'userHot'){
            self.userHotNum = contentObj.data.msg;
          }
          if(contentObj.data.cmd === 'quitroom') {
            self.isLiveDead = true
            if (self.heartTimeout) {
              clearTimeout(self.heartTimeout)
            }
            // //alert('主动挂断直播间')
            if (player) player.destroy()
            player = null
          }
          // self.onRecvRoomCustomMsg && self.onRecvRoomCustomMsg({
          //   roomID: roomInfo.roomID,
          //   userID: msg.fromAccountNick,
          //   userName: msg.userName,
          //   userAvatar: msg.userAvatar,
          //   cmd: msg.cmd,
          //   message: msg.content,
          //   time: msg.time
          // })
        } else if (contentObj.cmd === 'notifyPusherChange') {
        } else if (contentObj.cmd === 'linkmic') {
          console.log('+++++++++++')
          if (contentObj.data.type && contentObj.data.type === 'request') {
            self.onRequestJoinAnchor({
              userID: msg.fromAccountNick,
              userName: contentObj.data.userName,
              userAvatar: contentObj.data.userAvatar
            })
          } else if (contentObj.data.type && contentObj.data.type === 'response') {
            if (contentObj.data.result === 'accept') {
              // requestJoinCallback && requestJoinCallback({
              //   errCode: 0,
              //   errMsg: ''
              // })
            } else if (contentObj.data.result === 'reject') {
              // requestJoinCallback && requestJoinCallback({
              //   errCode: -999,
              //   errMsg: '主播拒绝了你的请求'
              // })
            } else if (contentObj.data.result === 'linkmic_success') {
              console.log('linkmic_success1')
              // event2.$emit({
              //   name: 'linkmic_success',
              //   data: true
              // })
            }
          } else if (contentObj.data.type && contentObj.data.type === 'kickout') {
            event.onKickoutJoinAnchor && event.onKickoutJoinAnchor({
              roomID: contentObj.data.roomID
            })
          } else if (contentObj.data.type && contentObj.data.type === 'starLiveImCustomMsg'){
            // //alert(111)
          }
        } else if (contentObj.cmd === '' || contentObj.cmd === undefined) {
          self.onRecvRoomTextMsg && self.onRecvRoomTextMsg({
            message: contentObj,
            time: msg.time
          })
        }
      }
    },
    heartbeat () {
      if(this.heartTimeout){
        clearTimeout(this.heartTimeout)
      }
      this.requestNum = 1;
      console.log('心跳了')
      //直播间还存活
      if(this.isLiveDead){
        this.isLiveDead = false;
        this.startLivePlay()
        // //alert('直播间重启了')
      }
      if(this.livestatus){
        this.livestatus = false;
        this.startLivePlay()
      }
      this.heartbeatTimeout()
    },
    heartbeatTimeout () {
      
      this.heartTimeout = setTimeout(()=>{
        //直播间挂了
        if (this.requestNum >=2) {
          // this.isLiveDead = true
          // clearTimeout(this.heartTimeout)
          this.requestNum = 1
          console.log('是心跳挂了')
          if (player) player.destroy()
          player = null;
          this.livestatus = true;
          console.log('zhelima')
          this.getliveDetail(this.studioCode)
        }else{
          this.$weui.toast('主播当前网络不佳', {
            duration: 2000,
            className: 'weui-toast-center'
          })
          this.requestNum += 1;
          this.heartbeatTimeout()
        }
          // //alert('直播间销毁了')
      },40000)
    },
    onRecvRoomTextMsg (ret) {
      var self = this
      console.log('onRecvRoomTextMsg called, ret: ', ret)
      //   app.setMsg(ret)
      if (ret.message.from === '@TIM#SYSTEM' && (ret.message.payload.operationType === 5 || ret.message.payload.groupJoinType === 1)) {
        if (ret.message.payload.operationType === 5) {
          self && self.onRoomEvent({ tag: 'roomClosed', code: -9006, detail: '房间已经解散了' })
        }
      } else if (ret.type === 'getGroupProfile') {
        self && self.onRoomEvent({ tag: 'memberCount', code: 0, detail: ret })
      } else {
        self.onRoomEvent({
          tag: 'recvTextMsg',
          code: 0,
          detail: ret
        })
      }
    },
    onRequestJoinAnchor (pusher) {
      var self = this
      console.log('onRequestJoinAnchor() called, pusher = ', JSON.stringify(pusher))
      self.onRoomEvent({
        tag: 'requestJoinAnchor',
        code: 0,
        detail: pusher
      })
    },
    /* eslint-disable */
    onRoomEvent: function (e) {
      var self = this
      var args = e.detail
      if (!args.tag) {
        args.tag = e.tag
      }
      console.log('onRoomEvent', args, e)
      // var userid = this.imUserId
      var imUserId = this.imUserId
      switch (args.tag) {
        case 'canlinkmic': {
          var message = e.detail.detail.message
          if (e.detail.detail === '1' || message === '1') {
            self.setData({
              isconnection: false,
              linkman: false
            })
            if (self.data.timer_ing) {
              clearInterval(self.data.timer_ing)
            }
          } else {
            var temp = args.detail.data.pushers[1]
            var linkman = { nickname: temp.userName, avatar: temp.userAvatar, userId: temp.userID }
            if (temp.userID !== imUserId) {
              self.setData({
                mic: 0
              })
            }
            self.setData({
              isconnection: true,
              linkman: linkman,
              avatarurl: linkman.avatar
            })
          }
          break
        }
        case 'memberCount': {
          // console.log(args.detail.message.memberCount, 'memberCount')
          // self.data.audienceslist.audienceCount = args.detail.message.payload.memberCount;
          // self.setData({
          //   audienceslist: { audienceCount: args.detail.message.memberCount>1?args.detail.message.memberCount-1:args.detail.message.memberCount }
          // })
          break
        }
        case 'roomClosed': {
          if (self.data.showModalBox) {
            self.setData({
              showEndModal: true
            })
            self.data.roomStatus = args.tag
            // self.log_video(8, self.data.cons_id, self.data.call_id, self.data.roomSessionId)
            // self.component.stop()
          } else {
            // wx.showModal({
            //   content: '店员已挂断连线',
            //   confirmColor:'#FD4A2C',
            //   showCancel: false,
            //   success (res) {
            //     if (res.confirm) {
            //       self.setData({
            //         small:''
            //       },()=>{
            //         self.data.roomStatus = args.tag
            //         self.log_video(8, self.data.cons_id, self.data.call_id, self.data.roomSessionId);
            //       })
            //     } else if (res.cancel) {
            //       console.log('用户点击取消')
            //     }
            //   }
            // });
          }
          break
        }
        case 'error': {
          self.setData({
            small: ''
          })
          if (args.code === -9007) {
            // wx.showModal({
            //   content: '直播间已关闭',
            //   confirmColor:'#FD4A2C',
            //   showCancel: false,
            //   duration:30000,
            //   success(res){
            //     if (res.confirm) {
            //       self.onBack()
            //     }
            //   }
            // })
            break
          }
          if (args.code === -9003 || args.detail === 'enterRoom 失败') {
            if (this.data.phonemodalShow) {
              // wx.showLoading({
              //   title: '直播间加载中',
              // })
            }
            // return
            // var res = app.mlvbuserSig()
            // res.then((resvar) => {
            //   if (resvar) {
            //     if (self.data.relogin < 1) {
            //       // wx.hideLoading()
            //       self.component && self.component.start(self.data.mic, function (nowroominfo) {
            //         self.setData({
            //           roomSessionId: nowroominfo.roomSessionId,
            //           live_id: nowroominfo.liveStreamId,
            //           shop_id: nowroominfo.shopId
            //         }, function () {
            //           self.data.isStarted = true
            //           self.getshop();
            //           if(self.data.live_id > 0){
            //             self.setData({
            //               super:1,
            //               small:'push'
            //             })
            //             app.globalData.minWin = true
            //             self.data.super = 1
            //           }
            //           // self.lookgoods(nowroominfo.shopId)
            //           // self.getConlist(nowroominfo.shopId)
            //           // self.getCanLink()
            //         })
            //       });
            //       self.data.relogin = self.data.relogin + 1
            //     } else {
            //       self.setData({
            //         show_content: '直播间已关闭',
            //         show_content_first: '提示',
            //         show_status: 2,
            //         showModal: false,
            //         small:''
            //       })
            //     }
            //   }
            // })
            break
          }
          if (args.code === 5000) {
            if(this.data.mic&&this.data.isStarted&&this.data.shouldExit){
              // wx.showToast({
              //   title: '连麦已经断开，可重新申请连麦',
              //   icon:'none'
              // })
            }
            this.data.shouldExit = true
            
            this.setData({
              mic: 0,
              isconnection: false
            })
            this.data.mic = 0
            this.data.isconnection = false
            // this.closeCamera()
            // this.component&&this.component.quitLink()
            this.data.isQuitLink = true
          } else {
            console.error('收到error:', args)
            if (args.code !== -9004) {
              console.log('问题呀1')
              self.setData({
                small: ''
              })
              //如果是非小窗模式下
              if (!app.globalData.minwin) {
                // setTimeout(() => {
                //   wx.navigateBack({ delta: 1 })
                // }, 1500)
              } else {
                console.log(getCurrentPages(),'getCurrentPagesgetCurrentPages')
              }
            } else {
              self.setData({
                linked: false,
                phoneNum: '',
                linkman: false
              })
              // wx.showToast({
              //   title: args.detail,
              //   icon: 'none'
              // });
            }
          }
          break
        }
        case 'linkOn': { // 连麦连上
          // self.setData({
          //   linked: true,
          //   mic: 1,
          //   phoneNum: '',
          //   title_name: '视频逛店中',
          //   small:'push',
          //   myName: wx.getStorageSync('userinfo').nickname
          // })
          // self.data.isQuitLink=false;
          // app.globalData.minWin = true;
          // //记录直播
          // self.log_video(5, self.data.cons_id, self.data.call_id, self.data.roomSessionId);
          break
        }
        case 'linkOut': { //连麦断开
          self.setData({
            linked: false,
            mic: 0,
            phoneNum: ''
          })
          self.data.isQuitLink = true
          break
        }

        case 'roomCustomMsg': {
          console.log('收到系统消息:', e.detail.detail)
          var cmd = e.detail.detail.cmd  
          if (cmd === 'cmdSendRecommendGoods') {//发送商品
            // self.lookgoods(self.data.roomSessionId)
            // self.lookgoods2(e.detail.detail.message)
            // self.lookgoods()
            break
          } else if (cmd === 'notifyPusherExit'){
            console.log('notifyPusherExit222222', e)
            let msg = e.detail.detail.message
            if(msg){
              self.setData({
                isconnection: false,
                linkman: false,
                avatarurl:'',
                mic:0
              })
              try {
                var value = wx.getStorageSync('userid')
                if (value) {
                  self.component&&self.component.notifyPusherExit()
                  // Do something with return value
                }
              } catch (e) {
                // Do something when catch error
              }
              // if(wx.getStorageSync('userid')==msg.userID){
              //   self.component&&self.component.notifyPusherExit()
              // }
            }
            break
          } else if (cmd === 'notifyPusherEnter') {
            console.log('notifyPusherEnter222222',e)
            let msg = e.detail.detail.message
            if(msg){
              var temp = JSON.parse(msg);
              var linkman = { nickname: temp.userName, avatar: temp.userAvatar,userId:temp.userID }
              // self.setData({
              //   isconnection: true,
              //   linkman: linkman,
              //   avatarurl: linkman.avatar,
              //   myName: wx.getStorageSync('nickname')
            
              // })
              console.log(msg)
              try {
                // var value = wx.getStorageSync('userid')
                // if (value) {
                //   // wx.showToast({
                //   //   title: 'notifyPusherEnter!UserId='+msg.userID
                //   // })
                //   // self.gettask('anchor')
                //   // self.gettask('livecall')
                //   self.component&&self.component.notifyPusherEnter()
                //   // Do something with return value
                // }
              } catch (e) {
                // Do something when catch error
              }
              // if(wx.getStorageSync('userid')==msg.userID){
              //   wx.showToast({
              //     title: 'notifyPusherEnter!UserId='+msg.userID
              //   })
              //   self.component&&self.component.notifyPusherEnter()
              // }
            }
            // 
            break
          }else if(cmd=='cmdKickOutLinkMic'){//踢掉
            // self.closeCamera()
            // self.component&&self.component.quitLink()
            // self.setData({
            //   mic:0
            // })
            // self.data.isQuitLink=true;
            // // liveroom.quitJoinAnchor()
            // break;
          } else if (cmd=='starLiveImCustomMsg') {
            self.getLivingCoupon(self.studioCode)
            self.getLivingCouponList(self.studioCode)
            self.getliveDetail(self.studioCode)
          } else if (cmd == '发送优惠券') {
            self.havecoupon();
            break;
          }else if (cmd == 'cmdEnabledLinkMic'){//监听是否可连接主播
            self.setData({
              lianMaiFlag:Number.parseInt(e.detail.detail.message)
            })
            // self.getShopCons((res)=>{
            //   console.log(res,'getShopCons')
            // })
            break;
          }else if (cmd == 'cmdGroupUserChange') {
            var data = JSON.parse(e.detail.detail.message);
            // console.log(data);
          
            self.setData({
              audienceslist: { audienceCount: data.watchNum }
            })

            var audienceslist_data = data.user;
            self.getimg_weiguan(audienceslist_data);

            // if (message == '进入围观') {
            //   if (e.detail.detail.userName != undefined) {
            //     this.msglist(e.detail.detail.userName, message);

            //   }
            // }
            break;
          }
          
          break
        }
        case 'recvTextMsg': {
          console.log('收到消息:', args);
          self.msgList.push(args);
          self.$nextTick(()=>{
            if(args){
              if(self.isShowTop && this.$refs.msgScroll.scrollHeight>self.initialH){// 评论未触底且留言框大于初始大小
                self.isShowNews = true;
              }else{
                self.isShowNews = false;
                self.$refs.msgScroll.scrollTo({top: this.$refs.msgScroll.scrollHeight>self.initialH?this.$refs.msgScroll.scrollHeight+80:''});
              }
            }
          })

          
          break;

        }
        case 'requestJoinAnchor': { //收到连麦请求
          var jioner = args.detail;
          var showBeginTime = Math.round(Date.now());
          wx.showModal({
            content: `${jioner.userName} 请求连麦`,
            cancelText: '拒绝',
            confirmText: '接受',
            confirmColor:'#FD4A2C',
            success: function (sm) {
              var timeLapse = Math.round(Date.now()) - showBeginTime;
              if (timeLapse < 10000) {
                if (sm.confirm) {
                  console.log('用户点击同意')
                  self.component && self.component.respondJoinAnchor(true, jioner);
                } else if (sm.cancel) {
                  console.log('用户点击取消')
                  self.component && self.component.respondJoinAnchor(false, jioner);
                }
              } else {
                wx.showToast({
                  title: '连麦超时',
                })
              }
            }
          })
          break;
        }

        case 'changeaudienceCount': {

          var temp = e.detail.detail.audiences;
          self.setData({
            audienceslist: { audienceCount: temp.audienceCount }
          })
          break
        }
        case 'changeaudiences': {

          var temp = e.detail.detail.audiences;
          var userinfo = false;
          var audienceslist_data = temp.audiences;
          self.getimg_weiguan(audienceslist_data);

          break
        }
        default: {
          console.log('onRoomEvent default: ', e)
          break;
        }
      }
    },
    /* eslint-disable */
    sendTextMsg(options) {
      let textMsg = this.textMsg
      if (!textMsg || !textMsg.replace(/^\s*|\s*$/g, '')) {
        console.log('sendRoomTextMsg参数错误', options)
        return
      }
      if(textMsg.length > 30){
        this.$weui.toast('评论文字不能超过30个字', {
          duration: 2000,
          className: 'weui-toast-center'
        })
        return
      }
      if(textMsg.length === 0){
        this.$weui.toast('请输入评论内容，不能为空！', {
          duration: 2000,
          className: 'weui-toast-center'
        })
        return
      }
      if (this.msgTimeout) {
        return
      }
      this.msgTimeout = setTimeout(()=>{
        if (this.msgTimeout){
          clearTimeout(this.msgTimeout)
          this.msgTimeout = null
        }
      },500)
      this.sendCustomMsg({
        data: {
          cmd: 'CustomTextMsg',
          data: {
            nickName: this.accountInfo.nickName,
            messageType: 0,
            headPic: this.accountInfo.avatar
          }
        },
        text: textMsg
      }, function () {
        options.success && options.success();
      })
    },
    /**
     * 发送自定义消息
     * 一条custom消息+一条text消息
     * 自定义，用于携带头像与昵称（其他端使用精简版text不能携带）
     */
     /* eslint-disable */
    sendCustomMsg(msg, callback) {
        console.log(msg);
        //  console.log(JSON.parse(msg.data))
        //  debugger;
        // 发送文本消息，Web 端与小程序端相同
        // 1. 创建消息实例，接口返回的实例可以上屏
        // 2. 创建消息实例，接口返回的实例可以上屏
        let self = this
        let message = tim.createCustomMessage({
            to: self.liveObj.groupId,
            conversationType: TIM.TYPES.CONV_GROUP,
            // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
            // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
            // priority: TIM.TYPES.MSG_PRIORITY_HIGH,
            payload: {
                data: typeof msg.data == 'string' ? msg.data : JSON.stringify(msg.data),
                description: '',
                extension: ''
            }
        });
        let message2 = tim.createTextMessage({
            to: self.liveObj.groupId,
            conversationType: TIM.TYPES.CONV_GROUP,
            // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
            // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
            // priority: TIM.TYPES.MSG_PRIORITY_NORMAL,
            payload: {
                text: msg.text
            }
        });
        console.log(message)
        message._elements.push(message2._elements[0])

        
        // 3. 发送消息
        let promise = tim.sendMessage(message);
        promise.then(function (imResponse) {
            // 发送成功
            console.log(imResponse, '444');
            if(imResponse.data.message._elements&&imResponse.data.message['_elements'][1]){
              let msg = imResponse.data.message['_elements'][1]
              self.msgList.push({
                message: msg.content.text,
                messageType: 0,
                roomID: '',
                tag: 'recvTextMsg',
                time: '',
                userAvatar: self.accountInfo.avatar,
                userID: self.accountInfo.userID,
                userName: self.accountInfo.nickName
              })
              self.textMsg = '';
              buriedPoint('SEND_A_BARRAGE', self.liveObj.studioCode);
              
            } 
            self.$refs.input.blur();
            self.$nextTick(()=>{
               if(self.isShowTop && self.$refs.msgScroll.scrollHeight>self.initialH){ // 评论未触底且留言框大于初始大小
                self.isShowNews = true;
              }else{
                self.isShowNews = false;
                self.$refs.msgScroll.scrollTo({top: self.$refs.msgScroll.scrollHeight>self.initialH?self.$refs.msgScroll.scrollHeight+80:''});
              }
            })
        }).catch(function (imError) {
            // 发送失败
            console.warn('sendMessage error:', imError);
        });
        
        console.log(message)
    },
    // 获取焦点
    focusInput () {
      this.isFocus = true
    },
    // 失去焦点
    blurInput () {
      window.scroll(0, 0);
      setTimeout(()=>{
        this.isFocus = false
      },500) 
    },
    // 显示规则
    showRuleWrap () {
      this.showRule = true
      setTimeout(()=>{
        this.showRule2 = true
      },50)
    },
    // 回到评论区底部最新的一条消息
    viewMessage(){
      this.$refs.msgScroll.scrollTo({top: (this.$refs.msgScroll.scrollHeight-this.initialH)});
      this.isShowNews = false;
      this.isShowTop = false;
    },
    closeRuleWrap () {
      this.showRule2 = false
      setTimeout(()=>{
        this.showRule = false
      },500)
    },
    // 显示购物车
    showCartListWrap () {
      this.getCartList()
      this.showCartList = true
      setTimeout(()=>{
        this.showCartList2 = true
      },50)
    },
    closeshowCartListWrap () {
      this.showCartList2 = false
      setTimeout(()=>{
        this.showCartList = false
      },500)
    },
    // 显示分享
    showShareWrap () {
      this.shareBtnWrap = true
      buriedPoint('SHARE_LIVE', this.liveObj.studioCode)
      setTimeout(()=>{
        this.shareBtnWrap2 = true
      },50)
    },
    closeShareWrap () {
      this.shareBtnWrap2 = false
      setTimeout(()=>{
        this.shareBtnWrap = false
      },300)
    },
     // 显示分享
    showPoster () {
      this.getSharePoster('POSTER').then((res)=>{
        this.posterImg = res
        this.closeShareWrap()
        this.showPosterWrap = true
        setTimeout(()=>{
          this.showPosterWrap2 = true
        },50)
      })
      
    },

    closePoster () {
      this.showPosterWrap2 = false
      setTimeout(()=>{
        this.showPosterWrap = false
      },300)
    },
    catchStop () {
    },
    doNothing () {
      // this.$refs.input.blur()
      console.log('doNothing')
    },
    //查询正在直播商品信息
    getLivingCoupon (studioCode) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/star/live/manage/query/live/studio/living/coupon',
          params: {
            studioCode: studioCode
          }
        })
        .then(res => {
          if (res.success) {
            this.livingCoupon = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    //查询直播间购物车
    getLivingCouponList (studioCode) {
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/star/live/manage/query/live/studio/rel/coupon',
          params: {
            studioCode: studioCode
          }
        })
        .then(res => {
          if (res.success) {
            this.productList = res.data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取直播信息
    getliveDetail (studioCode) {
      console.log('laile')
      let self = this
      self.$fly
        .request({
          method: 'get',
          url: '/star/live/manage/star/live/studio/detail/info/for/h5/by/code',
          params: {
            studioCode: studioCode
          }
        })
        .then(res => {
          if (res.success) {
            res.data.timeDescribe.forEach(item => {
              item.startTime = jsonDateFormat(item.startTime, 'minute')
              item.endTime = jsonDateFormat(item.endTime, 'minute')
            })
            self.liveObj = res.data;
            if (self.liveObj.pullAddress && self.liveObj.status === 'PLAYING') {
              if(!this.livestatus){
                self.startLivePlay()
              }
            }else{
              self.isLiveDead = true
            }
            document.title = self.liveObj.studioName || '直播'
            self.popularizeId = res.data.popularizeId
            if (self.popularizeId) {
              self.requestGetLiveDetail()
            }else{
              self.liveWatchTime = 0
            }
            self.loginIM()
            // self.wxShare(self.liveObj.shareTitle, self.liveObj.studioName, self.liveObj.liveCoverUrl, null)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    filterPrice (price, type) {
      let newPrice = price+''
      if (!price) {
        return '00'
      } else {
        if (type === 1){
          return newPrice.split('.')[0]||'00'
        }else{
          return newPrice.split('.')[1]||'00'
        }
      }
    },
    getSharePoster (type) {
      let self = this
      return new Promise((resolve,reject)=>{
        self.$fly
        .request({
          method: 'get',
          url: '/live/manage/star/live/share/poster',
          params: {
            studioCode: self.studioCode,
            activityId: self.activityId,
            type: type
          }
        })
        .then(res => {
          if (res.success) {
            if(type === 'POSTER'){
              resolve('data:image/jpeg;base64,'+res.data)
            }else{
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
      })
    },
    copyLink (data) {
      let self = this
      self.getSharePoster('TITLE').then((res)=>{
        console.log(res,'shareLink')
        self.shareLink = res
        // 安卓实现方法：
        self.$nextTick(()=>{
          setTimeout(() => {
            if (!self.isiOS) {
              document.getElementById('copy_content').select();   //选择所要复制的文本节点
              document.exexCommand('copy');   //执行浏览器的copy命令实现复制   
            } else {
              // IOS实现方法：
              // window.getSelection().removeAllRanges();   //将页面所有的文本区域都从选区中移除
              // var range =  document.createRange();   //创建一个文本区域
              // var test = document.getElementById('copy_content');  //获取所需要复制的节点
              // range.selectNode(test);   //将我们的所选节点添加到文本区域中
              // window.getSelection().addRange(range);  //将文本区域添加至选区中
              // document.execCommand('copy');   //执行浏览器的复制命令
              // window.getSelection().removeAllRanges();  //最后再移除选区中的所有文本区域
              const body = document.body;
              const input = document.createElement("input");
              body.append(input);
              input.style.opacity = 0;
              input.value = res;
              input.setAttribute("readOnly",'true');
              input.select();
              input.setSelectionRange(0, input.value.length);
              document.execCommand("Copy");
              input.blur();
              input.remove();
            }
            let clipboard = new this.$clipboard(".shareBtn");
            clipboard.on('success', function () {
              console.log('复制成功！')
              self.$weui.toast('复制成功了', {
                duration: 2000,
                className: 'weui-toast-center'
              })
            });
            clipboard.on('error', function () {
              console.log('复制失败，请手动选择复制！')
              //获取点击的值
            });
          },300)
          self.$weui.toast('复制成功', {
            duration: 2000,
            className: 'weui-toast-center'
          })
        })
       
      })
    },
    isiOS () {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return isiOS
    },
    goBuy (studioCode, couponCode) {
      console.log(this.liveObj,'111')
      buriedPoint('BUY_COUPON', this.liveObj.studioCode)
      this.$router.push('/confirmOrder?studioCode=' + studioCode + '&couponCode=' + couponCode + '&popularizeNo=' +this.liveObj.popularizeNo)
    },
    goMine () {
      buriedPoint('MY_STAR', this.liveObj.studioCode)
      this.$router.push('/mine')
    },
    getCartList () {
      this.getLivingCouponList(this.studioCode)
    },
    // 滚动查看最新消息
    msgScroll (e) {
      let msgScrollTop = this.$refs.msgScroll.scrollTop;
      let scroTop = this.$refs.msgScroll.scrollHeight-this.initialH;
      if(msgScrollTop<scroTop-1){
        this.isShowTop = true;
      }else{
        this.isShowTop = false;
        this.isShowNews = false
      }
    },

    sendInput(){
      this.$refs.sendInput.addEventListener('mousedown',(e)=>{
        console.log('mousedown')
        e.preventDefault();
      })
      this.$refs.input.blur();
    },
  },
  mounted () {
    //alert(9)
    this.sendInput();
  },
  beforeRouteLeave (to, form, next) {
    this.clearTimeInterval()
    clearTimeout(this.heartTimeout)
    this.quitGroup()
    if (player) player.destroy()
    player = null
    next()
  },
  activated () {
    let self = this;
    //alert(8)
    // 评论框初始大小
    self.initialH = self.$refs.msgScroll.scrollHeight;
    self.deviceType = parseInt(localStorage.getItem('USER_DEVICE_TYPE'))
    /* if (self.$route.query.code && self.$route.query.code !== localStorage.getItem('authorCode')) {
      localStorage.setItem('authorCode', self.$route.query.code)
    } */
    if (self.$route.query.activityId) {
      // url参数有activityId时重新存缓存
      localStorage.setItem('activityId', self.$route.query.activityId)
      localStorage.removeItem('saleOrgType')
      localStorage.removeItem('saleOrgNo')
      localStorage.removeItem('clerkId')
      localStorage.removeItem('studioCode')
      localStorage.removeItem('activityId')
      if (self.$route.query.saleOrgType) {
        localStorage.setItem('saleOrgType', self.$route.query.saleOrgType)
      }
      if (self.$route.query.saleOrgNo) {
        localStorage.setItem('saleOrgNo', self.$route.query.saleOrgNo)
      }
      if (self.$route.query.clerkId && self.$route.query.clerkId !== '' && Number.isInteger(parseInt(self.$route.query.clerkId))) {
        localStorage.setItem('clerkId', self.$route.query.clerkId)
      }
      if (self.$route.query.studioCode) {
        localStorage.setItem('studioCode', self.$route.query.studioCode)
      }
      if (self.$route.query.activityId) {
        localStorage.setItem('activityId', self.$route.query.activityId)
      }
    }
    console.log( self.$route.query,'2211')
    self.studioCode = localStorage.getItem('studioCode')
    self.activityId = localStorage.getItem('activityId')
    console.log(self,'self')
    self.getActivityInfo();
    //alert(7)
    if(self.studioCode){
      self.getLivingCoupon(self.studioCode)
      self.getliveDetail(self.studioCode)
    }
    self.getShareInfo();
    
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->

<style lang='less' scoped>
  #liveDetail{
    min-height: 100vh;
    background-color: #333333;
    #id_test_video{
      width: 750px;
      height: 422px;
      background-color: #000;
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99;
      .liveName{
        position: absolute;
        z-index: 999;
        top: 12px;
        left: 12px;
        width: 224px;
        height: 72px;
        background: rgba(0,0,0,.55);
        border-radius: 40px;
        display: flex;
        align-items: center;
        .nameTop{
          max-width: 130px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 26px;
          color: #ffffff;
          line-height: 28px;
        }
        .nameHot{
          display: flex;
          align-items: center;
          font-size: 22px;
          color: #ffffff;
          line-height: 28px;
          margin-top: 4px;
        }
        .liveLogo{
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin: auto 8px auto 6px;
        }
        .liveHot{
          width: 16px;
          height: 24px;
          margin-right: 4px;
        }
      }
      span{
        color: #fff;
        position:absolute;
        left: 0;
        top: 50%;
        text-align: center;
        transform: translateY(-50%);
        font-size: 30px;
        width: 100%;
      }
      .WAITING{
        color: #fff;
        position:absolute;
        left: 0;
        top: 50%;
        text-align: center;
        transform: translateY(-50%);
        font-size: 30px;
        width: 100%;
        img{
          display: block;
          width:80px;
          margin: 0 auto 24px;
        }
      }
    }
    .explainGoodsWrap{
      background-color:#333;
      position: fixed;
      top: 422px;
      width: 100%;
      z-index: 99;
      padding:10px 0;
      box-sizing:border-box;
    }
    .explainGoods{
      width: 710px;
      
     
      margin: 0 auto;
      height: 152px;
      background: #ffffff;
      border-radius: 8px;
      padding: 16px;
      box-sizing: border-box;
      display: flex;
      align-items:center;
      .explainGoodsImg{
        width: 180px;
        height: 120px;
        margin-right: 20px;
        border: 2px solid #f6f7f9;
        overflow: hidden;
        border-radius: 8px;
        img{
          display: block;
          width: 100%;
          height: 100%
        }
      }
      .explainGoodsDesc{
        width: 486px;
      }
      .explainGoodsName{
        display: flex;
        align-items: center;
        margin-bottom: 24px;
        .tip{
          width: 76px;
          height: 28px;
          line-height: 28px;
          background: linear-gradient(270deg,#fa865f, #eb263b);
          border-radius: 8px;
          text-align: center;
          color: #fff;
          font-size: 20px;
          font-weight: 400;
          margin-right: 10px;
        }
        .goodName{
          color: #030303;
          line-height: 40px;
          font-size: 28px;
          width: 440px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .explainGoodsPrice{
        display: flex;
        align-items:center;
        justify-content: space-between;
        .priceWrap{
          display: flex;
          align-items:center;
          .price{
            font-size: 32px;
            line-height: 38px;
            font-weight: 500;
            color: #E51515;
            margin-right: 8px;
            span{
              font-size: 24px;
            }
          }
          .stock{
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            line-height: 36px;
          }
        }
      }
      .explainGoodsBuyBtn{
        width: 136px;
        height: 52px;
        background: linear-gradient(270deg,#fa865f, #eb263b);
        border-radius: 26px;
        text-align: center;
        line-height: 52px;
        font-size: 26px;
        color: #fff;
        font-weight: 400;
        &.disabled{
          background:#cccccc;
        }
      }
    }
    .msgListWrap{
      height: 100vh;
      padding-top: 604px;
      width: 750px;
      margin: 0 auto;
      padding-left: 20px;
      padding-right: 130px;
      box-sizing:border-box;
      overflow-y:scroll;
      position:relative;
      padding-bottom: 120px;
      .msgList{
        color: #fff;
        .msgItem{
          background: rgba(0,0,0,0.35);
          border-radius: 8px;
          padding:8px 20px;
          margin-bottom: 12px;
          display: inline-block;
          font-size: 26px;
          .userName{
            color: #FFEBAA;
            margin-right: 10px;
          }
          .message{
            color: #fff;
            word-break:break-all;
          }
          &.gg{
            display: flex;
            padding:8px 10px;
            font-size: 24px;
            img{
              width: 48px;
              height: 48px;
              display: block;
              margin-right:10px;
              flex-shrink: 0;
            }
            .ggText{
              font-size: 24px;
              font-weight: 500;
              text-align: left;
              color: #ffebaa;
              line-height: 34px;
            }
          }
          .anchor{
            width: 62px;
            height: 30px;
            padding: 0 11px;
            background: linear-gradient(155deg,#00b4ff 0%, #1a74ff 100%);
            border-radius: 16px;
            font-size: 20px;
            color: #fff;
            margin-right: 10px;
          }
        }
        .newNews{
          width: 200px;
          height: 50px;
          line-height: 50px;
          background: #ffffff;
          border-radius: 26px;
          position: fixed;
          left: 20px;
          bottom: 102px;
          z-index: 999;
          font-size: 26px;
          color: #fa865f;
          text-align: center;
          img{
            width: 22px;
            height: 18px;
            margin-right: 10px;
          }
        }
      }
    }
    .ruleBtn{
      width: 96px;
      height: 48px;
      line-height: 48px;
      background: linear-gradient(270deg,#fa865f, #eb263b);
      border-radius: 24px 0px 0px 24px;
      position:fixed;
      right: 0;
      top: 612px;
      font-size: 26px;
      text-align: center;
      color: #fff;
    }
    .fixedBtnWrap{
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      background-color:#333;
      z-index: 99;
      .fixedBtn{
        width: 706px;
        padding:28px 0;
        margin: 0 auto;
        display: flex;
        align-items:center;
        .btnsWrap{
          display: flex;
          align-items:center;
          img{
            display: block;
            width: 70px;
            margin-left: 24px;
          }
        }
      }
      .fixedBtnInput{
        width: 424px;
        height: 70px;
        background: rgba(0,0,0,0.36);
        border-radius: 36px;
        &.isFocus{
          width: 614px;
        }
        input{
          display: block;
          width: 100%;
          height: 100%;
          background-color:transparent;
          border:none;
          outline: none;
          padding:0 26px;
          font-weight: 500;
          color: #fff;
          font-size: 28px;
          box-sizing: border-box;
          // &:disabled{
          //   color: #ccc;
          //   &::-webkit-input-placeholder { /* WebKit browsers */
          //     color: #ccc;
          //   }
          // }
          &::-webkit-input-placeholder { /* WebKit browsers */
            color: #fff;
            font-size: 28px;
          }

        }
      }
    }
    .ruleWrap{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color:rgba(0,0,0,.6);
      z-index: 999;
      display: none;
      &.show{
        display: block;
      }
      .ruleContent{
        width: 560px;
        height: 640px;
        background: #ffffff;
        border-radius: 8px;
        position:fixed;
        border-left-width: 50%;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding-top:48px;
        box-sizing:border-box;
        transition: all .5s;
        &.g_scale0 {
          transform: translate(-50%,-50%) scale(0);
        }
        &.g_scale1 {
          transform:translate(-50%,-50%) scale(1);
        }
        .ruleTitle{
          font-weight: 400;
          line-height: 50px;
          color: #000;
          margin-bottom: 32px;
          font-size: 36px;
          text-align: center;
        }
        .ruleText{
          font-size: 28px;
          color: #000;
          line-height: 40px;
          height: 390px;
          overflow-y: scroll;
          text-align: justify;
          padding-left:48px;
          padding-right:48px;
          width: 82%;
        }
        .ruleBtnWrap{
          padding: 16px 48px 24px;
          box-sizing:border-box;
          height: 120px;
          background: #ffffff;
          border-radius: 8px;
          position:absolute;
          width: 100%;
          left: 0;
          bottom:0;
          box-sizing:border-box;
          .innerBtn{
            height: 80px;
            background: linear-gradient(270deg,#fa865f, #eb263b);
            border-radius: 42px;
            line-height: 80px;
            text-align: center;
            color: #fff;
            font-size: 32px;
            font-weight: 500;
            width: 100%;
          }
        }
        
      }
    }
    .cartListWrap{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color:rgba(0,0,0,.6);
      z-index: 999;
      display: none;
      &.show{
        display: block;
      }
      .cartWrap{
        height: calc(100vh - 422px);
        position:absolute;
        width: 100%;
        left: 0;
        bottom: calc((-100vh + 422px));
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
        transition: all .5s;
        .img_box{
          width: 446px;
          margin: 110px;
          font-size: 30px;
          line-height: 30px;
          color: #666666;
          text-align: center;
          img{
            display: block;
            width: 100%
          }
        }
        &.show{
          bottom:0;
        }
        .closeBtn{
          width: 40px;
          position:absolute;
          right: 24px;
          top: 24px;
        }
        .cartTitle{
          display: flex;
          align-items:center;
          font-size: 30px;
          line-height: 42px;
          color: #030303;
          font-weight: 500;
          padding:32px 0 24px;
          justify-content: center;
          .cartNum{
            color: #FB4E2D;
            margin-left: 13px;
          }
        }
        .cartList{
          height: calc(100vh - 520px);
          padding:0 28px;
          box-sizing:border-box;
          overflow-y: scroll;
          -webkit-overflow-scrolling:touch;
          .cartItem{
            display: flex;
            align-items:center;
            margin-bottom: 50px;
            .cartImg{
              width: 180px;
              height: 120px;
              margin-right: 20px;
              background: #ffffff;
              border: 2px solid #f6f7f9;
              border-radius: 8px;
              flex-shrink:0;
            }
            .cartText{
              // flex-grow: 1;
              width: 490px;
              .proName{
                width: 100%;
               
                font-size: 28px;
                font-weight: 400;
                text-align: left;
                color: #030303;
                line-height: 40px;
                margin-bottom: 24px;
                display: flex;
                align-items:center;
               
                .tip{
                  width: 76px;
                  height: 28px;
                  background: linear-gradient(270deg,#fa865f, #eb263b);
                  border-radius: 8px;
                  line-height: 28px;
                  text-align: center;
                  font-size: 20px;
                  color: #fff;
                  margin-right: 10px;
                }
                .nameText{
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                  width: 460px;
                }
              }
              .proPriceWrap{
                display: flex;
                align-items:center;
                justify-content: space-between;
                .priceWrap{
                  display: flex;
                  align-items:center;
                  .priceText{
                    font-size: 32px;
                    line-height: 38px;
                    font-weight: 500;
                    color: #E51515;
                    margin-right: 8px;
                    span{
                      font-size: 24px;
                    }
                  }
                  .stock{
                    font-size: 26px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 26px;
                    position:relative;
                    // top: 4px;
                  }
                }
                .proBtn{
                  width: 136px;
                  height: 52px;
                  background: linear-gradient(270deg,#fa865f, #eb263b);
                  border-radius: 26px;
                  text-align: center;
                  line-height: 52px;
                  font-size: 26px;
                  color: #fff;
                  font-weight: 400;
                  &.disabled{
                    background:#cccccc;
                  }
                }
              }
            }
          }
        }
      }
    }
    .posterWrap{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color:rgba(0,0,0,.6);
      z-index: 999;
      display: none;
      &.show{
        display: block;
      }
      .posterWrapContent{
        width: 562px;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        color: #fff;
        position:absolute;
        transition:all .5s;
        &.g_scale0 {
          transform: translate(-50%,-50%) scale(0);
        }
        &.g_scale1 {
          transform:translate(-50%,-50%) scale(1);
        }
        .posterText{
          font-size: 36px;
          line-height: 50px;
          text-align: center;
          font-weight: 400;
          margin-bottom: 28px;
        }
        .posterImg{
          display: block;
          width: 100%;
          height: 784px;
          margin-bottom: 64px;
        }
        .closePoster{
          width: 80px;
          height: 80px;
          text-align: center;
          line-height: 80px;
          // background: rgba(255,255,255,0.2);
          border-radius: 40px;
          margin: 0 auto;
          img{
            display: block;
            width: 100%;
            height: 100%
          }
        }
      }
    }
    .shareWrap{
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color:rgba(0,0,0,.6);
      z-index: 999;
      display: none;
      &.show{
        display: block;
      }
      .shareContent{
        height: 294px;
        position:absolute;
        width: 100%;
        left: 0;
        bottom: -294px;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
        transition: all .3s;
        display: flex;
        align-items:center;
        justify-content: space-around;
        text-align: center;
        padding: 0 100px;
        box-sizing:border-box;
        &.show{
          bottom:0;
        }
        .shareBtn{
          width: 120px;
          text-align: center;
          font-size: 24px;
          line-height: 34px;
          color: #666;
          img{
            display: block;
            width: 100px;
            margin: 0 auto 12px;
          }
        }
        .closeShare{
          width: 32px;
          height: 32px;
          position:absolute;
          left: 50%;
          top:238px;
          transform: translateX(-50%);
        }
      }
      .shareGuide{
        width: 98px;
        position:absolute;
        right: 44px;
        top: 40px;
      }
      .shareGuideText{
        width: 292px;
        height: 112px;
        line-height: 112px;
        text-align: center;
        border: 2px dashed #fff;
        font-size: 36px;
        font-weight: 500;
        position: absolute;
        right: 70px;
        top:176px;
        color: #fff;
      }
    }
  }
  #errorScreen{
    position:fixed;
    width: 100%;
    height: 100%;
    background-color:#000;
    left: 0;
    top: 0;
    // z-index: 9999999;
    display: none;
    .screenText{
      position:absolute;
      top: 50%;
      text-align: center;
      color: #fff;
      font-size: 40px;
      width: 100%;
      transform: translateY(-50%);
      z-index: 9999999;
    }
  }
  @media screen and (orientation: portrait) {
    #errorScreen {
      display: none; 
    } 
  }
  @media screen and (orientation: landscape) {
    #errorScreen {
      display: block; 
    } 
  }
</style>



// WEBPACK FOOTER //
// src/views/activity/living.vue